import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ITarifa } from '@interfaces/tarifa.interface';
import { InsuranceService } from 'src/app/core/services/insurance.service';

@Component({
  selector: 'aig-link',
  imports: [RouterModule],
  templateUrl: './link.component.html',
  styleUrl: './link.component.scss',
})
export class LinkComponent implements OnInit {
  public IdTipoPoliza: number = 1;
  tarifas?: ITarifa;
  errorMessage?: string;

  constructor(private insuranceService: InsuranceService) {
    this.obtenerTarifas();
  }
  ngOnInit(): void {
  }

  obtenerTarifas() {
    this.insuranceService.obtenerTarifas(this.IdTipoPoliza).subscribe({
      next: (data) => {
        this.tarifas = data;
        this.errorMessage = undefined;
      },
      error: (err) => {
        this.errorMessage = 'Error al obtener tarifas';
        console.error(err);
      },
    });
  }
}
